'use client';

import { useState, useEffect } from 'react';
import Header from '@/components/common/Header';
import HeroSection from './HeroSection';
import PhilosophySection from './PhilosophySection';
import ApproachSection from './ApproachSection';
import ValuesSection from './ValuesSection';

export default function AboutContent() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <div className="pt-24" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-24">
        <HeroSection />
        <PhilosophySection />
        <ApproachSection />
        <ValuesSection />
      </main>
    </div>
  );
}